import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useWeatherSelector } from './useWeatherSelector';
import { useWeatherParams } from './useWeatherParams';
import { useWeatherQuery } from './useWeatherQuery';
import { useDashboardConfig } from '../../../hooks';
import { getImageMap, getWeatherImage } from '../../../api/weather/weather.utils';
const useStyles = makeStyles((theme) => ({
    title: {
        textAlign: 'center',
        fontSize: theme.font.size.big,
        fontWeight: theme.font.weight.normal,
        marginTop: 16,
        marginBottom: 12,
    },
    main: {
        height: 60,
        textAlign: 'center',
        width: '80%',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 15,
        '& > img': {
            height: '100%',
            float: 'left',
            width: 60,
            marginRight: 20,
        },
    },
    text: {
        float: 'left',
        textAlign: 'left',
        '& > span': {
            fontSize: 24,
            fontWeight: theme.font.weight.normal,
        },
    },
    textDescription: {
        position: 'relative',
        display: 'block',
        color: '#838485',
        width: '100%',
        overflow: 'hidden',
        whiteSpace: 'normal',
        lineHeight: 1.3,
        '& > span ': {
            wordBreak: 'break-all',
            position: 'relative',
            display: 'block',
            maxHeight: '3em',
            fontSize: theme.font.size.small,
            textTransform: 'uppercase',
        },
    },
    descriptionContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        padding: '0 20px',
        '& > div': {
            flex: '0 0 50%',
            marginBottom: 10,
        },
    },
    descriptionContainerTitle: {
        display: 'block',
        fontSize: theme.font.size.mediumSmall,
        color: '#9b9b9b',
    },
    descriptionContainerItem: {
        fontSize: theme.font.size.medium,
        fontWeight: theme.font.weight.normal,
    },
}));
export const WeatherContent = ({ widget }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const params = useWeatherParams(widget);
    const { data: weather } = useWeatherQuery(params);
    const weatherInfo = useWeatherSelector(weather);
    if (!weather || !weatherInfo) {
        return null;
    }
    const config = useDashboardConfig();
    const imageMap = useMemo(() => getImageMap(config.RESOURCES_BASE_URL), [config]);
    const weatherIcon = weatherInfo.weatherCode && getWeatherImage(weatherInfo.weatherCode, imageMap);
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", { className: classes.title }, (widget.config || {}).alias),
        React.createElement("div", { className: classes.main },
            weatherIcon && React.createElement("img", { alt: `${widget.config.RESOURCES_BASE_URL}`, src: weatherIcon }),
            React.createElement("div", { className: classes.text },
                React.createElement("span", null, `${Math.floor(+weatherInfo.currentTemperature)} ${weatherInfo.temperatureUOMLabel}`),
                React.createElement("div", { className: classes.textDescription },
                    React.createElement("span", null, weatherInfo.description)))),
        React.createElement("div", { className: classes.descriptionContainer },
            React.createElement("div", null,
                React.createElement("span", { className: classes.descriptionContainerTitle }, t('widget:weather:min_temperature')),
                React.createElement("span", { className: classes.descriptionContainerItem }, `${Math.floor(+weatherInfo.minTemperature)} ${weatherInfo.temperatureUOMLabel}`)),
            React.createElement("div", null,
                React.createElement("span", { className: classes.descriptionContainerTitle }, t('widget:weather:max_temperature')),
                React.createElement("span", { className: classes.descriptionContainerItem }, `${Math.floor(+weatherInfo.maxTemperature)} ${weatherInfo.temperatureUOMLabel}`)),
            React.createElement("div", null,
                React.createElement("span", { className: classes.descriptionContainerTitle }, t('widget:weather:probability')),
                React.createElement("span", { className: classes.descriptionContainerItem },
                    weatherInfo && weatherInfo.precipitationProbability,
                    "%")),
            React.createElement("div", null,
                React.createElement("span", { className: classes.descriptionContainerTitle }, t('widget:weather:speed')),
                React.createElement("span", { className: classes.descriptionContainerItem }, `${weatherInfo.avgWindSpeed} ${weatherInfo.windSpeedUOMLabel}`)))));
};
//# sourceMappingURL=WeatherContent.js.map